import { IHistoryItem } from '@/framework';
import { Framework } from '@/framework/instance';
import { ILayerProps } from '@/version-types';

export enum HistoryType {
    /** 拖入蒙版图层替换 */
    DROP_IMAGE = 'dropImage',
}

interface IHistoryDropImageData {
    item: {
        fromLayer: ILayerProps;
        oldTargetLayer: ILayerProps;
        newTargetLayer: ILayerProps;
        layerIndex: number;
    };
}

export class DropImageHistory extends Framework {
    constructor(identity: string) {
        super(identity);

        this.framework.history.register(HistoryType.DROP_IMAGE, {
            onRedoUndo: (historyItem: IHistoryItem<IHistoryDropImageData>, isRedo: boolean, isUndo: boolean) => {
                if (historyItem.isDirty) return;
                const { item } = historyItem.data.data;
                const { fromLayer, oldTargetLayer, newTargetLayer } = item;
                if (isUndo) {
                    this.framework.operate.delActiveLayer();
                    this.framework.stage.addOrUpdate(oldTargetLayer);
                    this.framework.stage.addOrUpdate(fromLayer);
                    this.framework.operate.setActiveLayer(fromLayer.id);
                }
                if (isRedo) {
                    this.framework.operate.delActiveLayer();
                    this.framework.operate.delLayer(fromLayer.id);
                    this.framework.stage.addOrUpdate(newTargetLayer);
                    this.framework.operate.setActiveLayer(newTargetLayer.id);
                }
            },
            onAfterRedoUndo: (historyItem: IHistoryItem<IHistoryDropImageData>) => {
                return {
                    message: [historyItem.data.data],
                };
            },
            onAfterWrite: (historyItem: IHistoryItem<IHistoryDropImageData>) => {
                return {
                    message: [historyItem.data.data],
                };
            },
            onBeforeRedoUndo: (historyItem: IHistoryItem<IHistoryDropImageData>, isRedo, isUndo, store) => {
                const { item } = historyItem.data.data;
                const { fromLayer, oldTargetLayer, newTargetLayer } = item;
                if (isUndo) {
                    historyItem.isDirty =
                        this.framework.checkLayerIsDirty({
                            originLayer: newTargetLayer,
                        }) || !!this.framework.getLayer(fromLayer.id);
                    store.set(historyItem.cursor, {
                        isDirty: historyItem.isDirty,
                    });
                }
                if (isRedo) {
                    const beforeData = store.get(historyItem.cursor);
                    if (!beforeData) {
                        historyItem.isDirty = true;
                        return;
                    }
                    historyItem.isDirty = beforeData.isDirty;
                    if (!historyItem.isDirty) {
                        historyItem.isDirty =
                            this.framework.checkLayerIsDirty({
                                originLayer: oldTargetLayer,
                            }) ||
                            this.framework.checkLayerIsDirty({
                                originLayer: fromLayer,
                            });
                    }
                }
            },
            onMessage: (message: [IHistoryDropImageData], isRedo, isUndo, isWrite) => {
                const { item } = message[0];
                const { fromLayer, oldTargetLayer, newTargetLayer } = item;
                if (isUndo) {
                    this.framework.operate.tryRefreshActiveLayer(oldTargetLayer.id);
                    this.framework.operate.tryRefreshActiveLayer(fromLayer.id);
                    this.framework.stage.addOrUpdate(oldTargetLayer);
                    this.framework.stage.addOrUpdate(fromLayer);
                }
                if (isRedo || isWrite) {
                    this.framework.operate.tryRemoveActiveLayer(fromLayer.id);
                    this.framework.operate.delLayer(fromLayer.id);
                    this.framework.stage.addOrUpdate(newTargetLayer);
                }
            },
        });
    }
}
